import Mail from '@/public/mail.svg';

type Props = {
  size?: number;
  className?: string;
};

export const MailIcon = ({ size, className }: Props) => {
  return <img width={size} className={className} height={size} src={Mail} alt="メールアイコン" />;
};
